import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as operation from 'state/global/subscription/operation';
import * as selector from 'state/global/subscription/selector';
import { getUserId } from 'util/auth';
import { useNotification } from 'hooks/useNotification';

export const Subscription = () => {
  const dispatch = useDispatch();
  const [openNotification] = useNotification();

  const { subscriptionMessage } = useSelector((state) => ({
    subscriptionMessage: selector.selectSubscriptionMessageInfo(state)
  }));

  useEffect(() => {
    const { newMessageId, messageObjects } = subscriptionMessage;

    if (subscriptionMessage.newMessageId) {
      const message = messageObjects[newMessageId];
      openNotification(newMessageId, message);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionMessage.newMessageId]);

  useEffect(() => {
    const subscribe = async () => {
      const userId = await getUserId();

      // Subscribe on notification topic
      dispatch(
        operation.subscribeNotificationAdded({
          userId
        })
      );

      // Subscribe on cleaning report topic
      dispatch(
        operation.subscribeCleaningReportAdded({
          userId
        })
      );
    };

    subscribe();
  }, [dispatch]);

  return <></>;
};
